// components/ExcelUploadPanel.tsx
import { Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import React from "react";

interface Props {
    fileList: any[];
    realFile?: File;
    onUpload: (options: any) => void;
    onRemove: () => void;
}
const formatFileSize = (bytes: number) => {
    if (!bytes) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`;
};
export const ExcelUploadPanel: React.FC<Props> = ({
                                                      fileList,
                                                      realFile,
                                                      onUpload,
                                                      onRemove,
                                                  }) => {
    return (
        <div style={{ marginBottom: 24 }}>
            <div style={{ marginBottom: 8 }}>
                <Upload
                    accept=".xls,.xlsx"
                    showUploadList={false}
                    fileList={fileList}
                    customRequest={onUpload}
                    maxCount={1}
                >
                    <Button type="primary" ghost icon={<UploadOutlined />}>
                        选择Excel文件
                    </Button>
                </Upload>

                <span style={{ marginLeft: 12, fontSize: 12, color: '#999' }}>
          支持 .xls、.xlsx 格式，最大 1MB
        </span>
            </div>

            {realFile && (
                <div
                    style={{
                        marginTop: 12,
                        padding: 16,
                        border: '1px dashed #d9d9d9',
                        borderRadius: 6,
                        backgroundColor: '#fafafa',
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        {/* 左侧文件信息 */}
                        <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 'bold', marginBottom: 8 }}>
                                文件信息
                            </div>

                            <Info label="文件名" value={realFile.name} mono />
                            <Info label="文件大小" value={formatFileSize(realFile.size)} />
                            <Info
                                label="修改时间"
                                value={new Date(realFile.lastModified).toLocaleString()}
                            />
                            <Info
                                label="文件类型"
                                value={realFile.type || 'application/vnd.ms-excel'}
                            />
                        </div>

                        {/* 右侧 */}
                        <div style={{ textAlign: 'center' }}>
                            <div
                                style={{
                                    width: 80,
                                    height: 80,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#1890ff',
                                    borderRadius: 8,
                                    color: '#fff',
                                    fontSize: 24,
                                    fontWeight: 'bold',
                                }}
                            >
                                XLS
                            </div>

                            <Button
                                type="link"
                                danger
                                size="small"
                                style={{ marginTop: 8 }}
                                onClick={onRemove}
                            >
                                移除
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const Info = ({
                  label,
                  value,
                  mono,
              }: {
    label: string;
    value: React.ReactNode;
    mono?: boolean;
}) => (
    <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
        <strong>{label}：</strong>
        <span style={mono ? { fontFamily: 'monospace' } : undefined}>
      {value}
    </span>
    </div>
);
